import { EmissionAllocation } from "api";
import { MRT_ColumnDef } from "material-react-table";
import { getFormattedDate } from "utils";

export const SETUPS_OVERVIEW_COLUMNS: MRT_ColumnDef<EmissionAllocation>[] = [
    {
        accessorKey: 'title',
        header: 'Title',
        minSize: 150,
        maxSize: 300,
    },
    {
        accessorKey: 'startDate',
        header: 'Start Date',
        minSize: 80,
        maxSize: 200,
        Cell: ({ cell }) => getFormattedDate(cell.getValue<string>(), '/'),
    },
    {
        accessorKey: 'endDate',
        header: 'End Date',
        minSize: 80,
        maxSize: 200,
        Cell: ({ cell }) => getFormattedDate(cell.getValue<string>(), '/'),
    },
];